
angular.module('qkr').controller('TallyController', ($scope, $rootScope,  $routeSegment, $uibModalInstance, $timeout,
                                                     savedReport, reportService, menuService, appConfig,
                                                     utils, gettextCatalog, merchantService, reportsErrorService) => {
    
    const vm = $scope;
    
    const now = new Date() * 1;
    const defaultScheduleInterval = 'daily';
    const reportType = 'Tally';
    const defaultScheduleHour = 17;
    const defaultScheduleMinute = 0;
    const defaultScheduleDay = utils.getDaysOfWeek()[0].name;
    const defaultScheduleDayOfMonth = 1;

    const isASavedReport = !!savedReport;

    vm.$routeSegment = $routeSegment;

    vm.canteenMenus = [];

    vm.daysOfMonth = reportService.getDaysOfMonth();
    // Drop down menu to choose which day to generate weekly report
    vm.daysOfWeek = utils.getDaysOfWeek();
    // Used to select which days a daily report should be generated on
    vm.days = utils.getDaysOfWeekWithSelected();
    vm.scheduleIntervals = reportService.getAnytimeMenuScheduleIntervals();
    vm.hours = reportService.getHours();
    vm.minutes = reportService.getMinutes();

    vm.form = {};

    vm.tallyReportSettings = {
        reportWaiting: false,
        showPopup: false,
        reportUrl: '',
        leadTime: 0,
        categoryCutOffTime: '',
        categoryLeadTime: 0,
        categoryScheduleTime: null,
        areAllCategoriesSelected: false,
        groupByList: [],
        template: {
            groupByList: []
        }
    };

    vm.tallyReport = {
        date: {
            startDate: now,
            startTime: reportService.getDateTime(0, 0, 0),
            endDate: now,
            endTime: reportService.getDateTime(23, 59, 59)
        },
        startTime: now,
        endTime: null,
        reportSpec: {
        }
    };

    vm.tallyReportTemplate = {
        reportSpec: {
            reportSubType:  reportType,
            scheduleInterval: defaultScheduleInterval,
            scheduleHour: defaultScheduleHour,
            scheduleMinute: defaultScheduleMinute,
            scheduleDay: defaultScheduleDay,
            scheduleDayOfMonth: defaultScheduleDayOfMonth,
            emailList: []
        }
    };

    // This is needed if the user is editing a template and they change from
    // Daily to weekly
    // If the schedule selected is not daily, and scheduleDay contains a ","
    // I.e. a list of days, then select the first day
    // E.g. if daily and "WED,THU,FRI", and weekly is selected, then the default
    // Day will be set to the first day in the list, i.e. WED
    vm.$watch('tallyReportTemplate.reportSpec.scheduleInterval', (newValue, oldValue) => {
        if (newValue !== 'daily' && vm.tallyReportTemplate.reportSpec.scheduleDay.indexOf(',') > -1) {
            const dayArray = vm.tallyReportTemplate.reportSpec.scheduleDay.split(',');
            vm.tallyReportTemplate.reportSpec.scheduleDay = dayArray[0];
        }
    });

    var poll = function(id, format, reportType) {
        const timeoutPoll = $timeout(() => {
            // Poll for report

            reportService.pollReport(id)
                .then((promise) => {
                        // Check if error on the report
                        if (promise.error) {
                            handleGenerateReportError(promise);
                        } else if (promise.reportType === 'no-data') {
                            vm.form.tallyReportForm.errors = {generate: gettextCatalog.getString('No data for this date')};
                            vm.tallyReportSettings.reportWaiting = false;
                        }
                        // Check if complete, otherwise poll again
                        else if (promise.percentComplete === 100) {
                            vm.form.tallyReportForm.errors = {};
                            vm.tallyReportSettings.reportWaiting = false;
                            vm.tallyReportSettings.showPopup = false;
                            vm.tallyReportSettings.reportUrl = appConfig.apiUrl + 'reportControl/' + promise.id + '/' + format;
                            window.location = vm.tallyReportSettings.reportUrl;
                        } else {
                            poll(id, format, reportType);
                        }
                    },
                    (error) => {
                        handleGenerateReportError(error);
                    });
        }, 2500);

        // When the DOM element is removed from the page, AngularJS will trigger
        // The $destroy event on
        // The scope. This gives us a chance to cancel any pending timer that we
        // May have.
        vm.$on(
            '$destroy',
            (event) => {
                $timeout.cancel(timeoutPoll);
            }
        );
    };

    function handleGenerateReportError(error) {
        let errors = {};

        if (vm.form.tallyReportForm.errors) {
            errors = vm.form.tallyReportForm.errors;
        }

        errors.generate = gettextCatalog.getString('Error generating report');
        vm.form.tallyReportForm.errors = errors;
        vm.tallyReportSettings.reportWaiting = false;
    }

    function setCutOffTime(newValue, isTallyReportTemplate) {
        let text;

        // Find the menu
        for (let i = 0; i < vm.canteenMenus.length; i++) {
            if (vm.canteenMenus[i].id === newValue) {
                const menu = vm.canteenMenus[i];
                if(isTallyReportTemplate) {
                    vm.tallyReportTemplate.isAnytimeMenu = !menu.availability.fixedPreorderType &&
                        !menu.availability.isPreorderable;
                } else {
                    vm.tallyReport.isAnytimeMenu = !menu.availability.fixedPreorderType &&
                        !menu.availability.isPreorderable;
                }

                if(isTallyReportTemplate) {
                    if (!menu.availability.cutoffOffsetInMinutes) {
                        text = '(' + gettextCatalog.getString('No Cut Off Time Set') + ')';
                        vm.tallyReportSettings.leadTime = 0;
                    } else {
                        text = '(' + utils.formatCutOff(menu.availability.cutoffOffsetInMinutes) + ')';
                        vm.tallyReportSettings.leadTime = utils.getCutOff(menu.availability.cutoffOffsetInMinutes)
                            .cutoffDays;
                    }
                    vm.tallyReportSettings.cutOffTime = text;
                }
            }
        }
    }

    function setCategoryCutOffTime(prodGroup, savedReport) {
        if (savedReport.addMenuItemsWithLeadTime && savedReport.filterMap.Category) {
            const filterList = savedReport.filterMap.Category;
            const categoryFilter = filterList.join(',');
            menuService.getLatestItemAvailabilityForCategories(prodGroup.id, categoryFilter).then((promise) => {
                if (promise.cutoffOffsetInMinutes) {
                    const text = '(' + utils.formatCutOff(promise.cutoffOffsetInMinutes) + ')';
                    vm.tallyReportSettings.categoryLeadTime = utils.getCutOff(promise.cutoffOffsetInMinutes).cutoffDays;
                    vm.tallyReportSettings.categoryCutOffTime = text;
                    vm.tallyReportSettings.categoryScheduleTime = promise.cutoffOffsetInMinutes;
                }
            });
        }
    }

    vm.$watch('tallyReportTemplate.reportSpec.prodGroup.id', (newValue, oldValue) => {
        setCutOffTime(newValue, true);
    });

    vm.$watch('tallyReport.reportSpec.prodGroup.id', (newValue, oldValue) => {
        setCutOffTime(newValue, false);
    });

    const getSelectedMenu = function(id) {
        for (let i = 0; i < vm.canteenMenus.length; i++) {
            if (vm.canteenMenus[i].id === id) {
                return vm.canteenMenus[i];
            }
        }
    };

    vm.showMenuWithLeadTime = function() {
        return vm.tallyReportSettings.leadTime > 0;
    };

    vm.showMenuItemWithLeadTime = function() {
        return vm.tallyReportSettings.categoryLeadTime > 0;
    };

    vm.generateTallyReport = function() {
        vm.tallyReportSettings.reportWaiting = true;

        const request = angular.copy(vm.tallyReport);
        request.reportSpec.scheduleInterval = 'once';
        request.startTime = utils.dateToServerDateString(vm.tallyReport.startTime);
        if (vm.tallyReport.isAnytimeMenu) {
            request.startTime = utils.dateTimeToServerDateTimeString(vm.tallyReport.date.startDate,
                vm.tallyReport.date.startTime); // Start of day
            request.endTime = utils.dateTimeToServerDateTimeString(vm.tallyReport.date.endDate,
                vm.tallyReport.date.endTime); // End of day
        } else {
            request.startTime = utils.dateToServerDateString(vm.tallyReport.startTime);
        }
        delete (request.date);
        // Just send prod group id
        request.reportSpec.prodGroup = {id: request.reportSpec.prodGroup.id};

        // Group By Expects a list
        request.reportSpec.groupBy = transformGroupByForSave(vm.tallyReport.reportSpec.groupBy);

        // Transform Filters
        request.reportSpec.filterMap = transformFiltersForSave();

        reportService.generateTallyReport(request)
            .then((promise) => {
                    poll(promise.id, 'pdf', 'tally');
                },
                (error) => {
                    handleGenerateReportError(error);
                });
    };

    vm.saveTallyReport = function() {
        if (!validateReport()) {
            return;
        }

        vm.saving = true;

        const request = angular.copy(vm.tallyReportTemplate.reportSpec);

        // Tally Report is scheduled for cut of time of the menu
        request.scheduleInterval = 'daily';

        const selectedMenu = getSelectedMenu(request.prodGroup.id);
        const isMenuAnytime = !selectedMenu.availability.fixedPreorderType && !selectedMenu.availability.isPreorderable;
        if (isMenuAnytime && vm.days) {
            request.scheduleDay = utils.getSelectedDaysList(vm.days);
        } else {
            request.scheduleDay = reportService.getDefaultDays();
        }

        // Set 09.00 if no value is set
        let cutoffOffsetInMinutes;
        if (request.addMenuItemsWithLeadTime) {
            cutoffOffsetInMinutes = vm.tallyReportSettings.categoryScheduleTime ?
                vm.tallyReportSettings.categoryScheduleTime : reportService.getDefaultCutOffTimeOffset();
            request.scheduleHour = utils.getCutOff(cutoffOffsetInMinutes).cutoffHour;
            request.scheduleMinute = utils.getCutOff(cutoffOffsetInMinutes).cutoffMinutes;
            request.addMenuWithLeadTime = false;
        } else if (!isMenuAnytime) {
            cutoffOffsetInMinutes = selectedMenu.availability.cutoffOffsetInMinutes ?
                selectedMenu.availability.cutoffOffsetInMinutes : reportService.getDefaultCutOffTimeOffset();
            request.scheduleHour = utils.getCutOff(cutoffOffsetInMinutes).cutoffHour;
            request.scheduleMinute = utils.getCutOff(cutoffOffsetInMinutes).cutoffMinutes;
        }

        // Just set prod group id
        request.prodGroup = {id: request.prodGroup.id};

        // Group By Expects a list
        request.groupBy = transformGroupByForSave(vm.tallyReportTemplate.reportSpec.groupBy);

        // Transform Filters
        request.filterMap = transformFiltersForSave();

        // Are we updating or creating, if savedReport object passed to modal we
        // Are updating, otherwise we are creating
        if (!isASavedReport) {
            request.id = null;
        }

        reportService.saveTallyReport(request, isASavedReport)
            .then(() => {
                $uibModalInstance.close(true);
            })
            .catch(err => {
                vm.form.tallyReportForm.errors = reportsErrorService.handleServerError(err.data.errors);
            })
            .finally(() => {
                vm.saving = false;
            });
    };

    function validateReport() {
        // Empty the errors list
        vm.errors = null;
        let valid = true;
        const errors = {};

        // Check name is set
        if (vm.form.tallyReportForm.name.$invalid) {
            errors.name = gettextCatalog.getString('Name is required');
            valid = false;
        }

        // Check at least 1 email is added
        if (vm.tallyReportTemplate.reportSpec.emailList.length <= 0) {
            errors.email = gettextCatalog.getString('At least 1 email address is required');
            valid = false;
        }

        vm.form.tallyReportForm.errors = errors;
        return valid;
    }

    vm.addTallyReportEmail = function() {
        // Gets ride of validation warning
        if (vm.form.tallyReportForm.errors && vm.form.tallyReportForm.errors.email) {
            vm.form.tallyReportForm.errors.email = '';
        }
        vm.tallyReportTemplate.reportSpec.emailList.push(vm.tallyReportSettings.email);
        vm.tallyReportSettings.email = '';
    };

    vm.removeTallyReportEmail = function(index) {
        vm.tallyReportTemplate.reportSpec.emailList.splice(index, 1);
    };

    vm.openFilterPopup = function(isGen) {
        vm.reducedFilterList = [];

        if (isGen) {
            angular.forEach(vm.tallyReportSettings.tallyReportFilters.filtersList, (filter) => {
                if ((utils.hasNoValue(filter.prodgroup)) || filter.prodgroup.id === vm.tallyReport.reportSpec.prodGroup.id) {
                    vm.reducedFilterList.push(filter);
                }
            });
            if (!vm.tallyReportSettings.filterBy) {
                vm.tallyReportSettings.filterBy = vm.reducedFilterList[0];
            }
            vm.tallyReportSettings.showFilterPopup = true;
        } else {
            angular.forEach(vm.tallyReportSettings.template.tallyReportFilters.filtersList, (filter) => {
                if (utils.hasNoValue(filter.prodgroup) || filter.prodgroup.id === vm.tallyReportTemplate.reportSpec.prodGroup.id) {
                    vm.reducedFilterList.push(filter);
                }
            });

            if (!vm.tallyReportSettings.template.filterBy || !_.isObject(vm.tallyReportSettings.template.filterBy)) {
                // Default the selected one to the first in the list
                vm.tallyReportSettings.template.filterBy = vm.reducedFilterList[0];
            }
            vm.tallyReportSettings.showTemplateFilterPopup = true;
        }
    };

    function transformFilters(filters, savedFilters) {
        // If all are deselected, this (pervesely means that server should not apply any filters.
        // Make the UI look reasonable
        let areAllDeselected = true;

        // Transform tallyReportFilters Add selected key to all options so we
        // Can use this as model for toggle on/off

        // Loop over each filter in filtersList so that the options can be set
        for (var i = 0; i < filters.filtersList.length; i++) {
            var filter = filters.filtersList[i];
            const filterName = filter.name;

            // Loop over each option for the filter
            for (var j = 0; j < filter.options.length; j++) {
                // Change option to object with name and selected, selected will
                // Be used for ng-model in toggle on/off
                const optionName = filter.options[j];
                filter.options[j] = {
                    name: optionName,
                    selected: false
                };

                // If we have saved filters i.e. we are editing a template then
                // Check if the option should be selected
                if (savedFilters) {
                    // Find saved filter from the savedFilters object using the filter name
                    const savedFilterOptions = savedFilters[filterName];

                    // If we found a filter then check the options in that filter
                    // If one of the options matched optionName then set it as selected
                    if (savedFilterOptions) {
                        if (savedFilterOptions.indexOf(optionName) > -1) {
                            filter.options[j].selected = true;
                            areAllDeselected = false;
                        }
                    }
                }
            }
        }

        // If nothing was selected, then everything is selected
        if (areAllDeselected) {
            for (var i = 0; i < filters.filtersList.length; i++) {
                var filter = filters.filtersList[i];
                for (var j = 0; j < filter.options.length; j++) {
                    filter.options[j].selected = true;
                }
            }
        }
        return filters;
    }

    function transformFiltersForSave() {
        const filterList = {};

        // Transform tallyReportFilters Add selected key to all options so we
        // Can use this as model for toggle on/off
        if (vm.reducedFilterList) {
            for (let i = 0; i < vm.reducedFilterList.length; i++) {
                // If they are all selected, then we don't send this list to the server.
                // This is important as if new filter values are added (e.g. a new product with a new category),
                // we don't want them excluded
                let areAllSelected = true;

                const tmpFilterList = [];
                const filter = vm.reducedFilterList[i];
                for (let j = 0; j < filter.options.length; j++) {
                    if (filter.options[j].selected) {
                        tmpFilterList.push(filter.options[j].name);
                    } else {
                        areAllSelected = false;
                    }
                }

                if (tmpFilterList.length > 0 && areAllSelected === false) {
                    filterList[[filter.name]] = tmpFilterList;
                }
            }
        }

        return filterList;
    }

    /**
     * Value returned as an array, set the first value as the selected value
     */
    function transformGroupBy(groupBy) {
        let tmp;

        if (groupBy && groupBy.length > 0) {
            tmp = groupBy[0];
        }

        return tmp;
    }

    /**
     * Server expects a list so create array from 1 item
     */
    function transformGroupByForSave(groupBy) {
        const tmp = [];

        if (groupBy) {
            tmp.push(groupBy);
        }

        return tmp;
    }

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    function loadFilters(savedReport) {
        vm.loading = true;
        reportService.getTallyReportFilters().then((promise) => {
            vm.tallyReportSettings.tallyReportFilters = transformFilters(angular.copy(promise));
            vm.tallyReportSettings.groupByList = angular.copy(_.uniq(promise.groupByList));
            vm.tallyReportSettings.template.groupByList = angular.copy(_.uniq(promise.groupByList));

            if (savedReport) {
                vm.tallyReportSettings.template.tallyReportFilters = transformFilters(angular.copy(promise),
                    savedReport.filterMap);
                vm.reducedFilterList = [];
                angular.forEach(vm.tallyReportSettings.template.tallyReportFilters.filtersList, (filter) => {
                    if (utils.hasNoValue(filter.prodgroup) ||
                        filter.prodgroup.id === vm.tallyReportTemplate.reportSpec.prodGroup.id) {
                        vm.reducedFilterList.push(filter);
                    }
                });
                vm.tallyReportTemplate.reportSpec.groupBy = transformGroupBy(savedReport.groupBy);
            } else {
                vm.tallyReportSettings.template.tallyReportFilters = transformFilters(angular.copy(promise));
            }
            vm.loading = false;
        });
    }

    function init() {
        // Get All Menus
        vm.loading = true;
        menuService.getMenus().then((promise) => {
            vm.canteenMenus = [];

            for (let i = 0; i < promise.length; i++) {
                const canteenMenu = promise [i];

                if (canteenMenu.availability !== null) {
                    vm.canteenMenus.push(canteenMenu);
                }
            }

            if (vm.canteenMenus.length > 0) {
                vm.tallyReport.reportSpec.prodGroup = angular.copy(vm.canteenMenus[0]);

                if (!isASavedReport) {
                    vm.tallyReportTemplate.reportSpec.prodGroup = angular.copy(vm.canteenMenus[0]);
                    setCutOffTime(vm.tallyReport.reportSpec.prodGroup.id, false);
                } else {
                    setCutOffTime(vm.tallyReportTemplate.reportSpec.prodGroup.id, true);
                }
            }
            loadFilters(savedReport);
            if (isASavedReport) {
                setCategoryCutOffTime(vm.tallyReportTemplate.reportSpec.prodGroup, savedReport);
            }
        });

        if (isASavedReport) {
            vm.tallyReportTemplate.reportSpec = savedReport;
            // ScheduleDayOfMonth is return as string from server
            vm.tallyReportTemplate.reportSpec.scheduleDayOfMonth =
                parseInt(vm.tallyReportTemplate.reportSpec.scheduleDayOfMonth);
            utils.setSelectedDays(vm.tallyReportTemplate.reportSpec.scheduleDay, vm.days);
        }
    }

    vm.getTextTip = function(value) {
        return value;
    };

    vm.changeDayEnabled = function(day) {
        day.selected = !day.selected;
    };

    const getLatestAvailabilityForCategories = function() {
        let categoryFilter;
        if (vm.reducedFilterList) {
            for (let i = 0; i < vm.reducedFilterList.length; i++) {
                let areAllSelected = true;
                const tmpFilterList = [];
                const filter = vm.reducedFilterList[i];
                if (filter.name === 'Category') {
                    for (let j = 0; j < filter.options.length; j++) {
                        if (filter.options[j].selected) {
                            tmpFilterList.push(filter.options[j].name);
                        } else {
                            areAllSelected = false;
                        }
                    }
                    if (tmpFilterList.length > 0 && areAllSelected === false) {
                        categoryFilter = tmpFilterList.join(',');
                    }
                }
            }
            if (categoryFilter) {
                vm.tallyReportSettings.areAllCategoriesSelected = false;
                menuService.getLatestItemAvailabilityForCategories(vm.tallyReportTemplate.reportSpec.prodGroup.id,
                    categoryFilter).then((promise) => {
                    if (promise.cutoffOffsetInMinutes) {
                        const text = '(' + utils.formatCutOff(promise.cutoffOffsetInMinutes) + ')';
                        vm.tallyReportSettings.categoryLeadTime = utils
                            .getCutOff(promise.cutoffOffsetInMinutes).cutoffDays;
                        vm.tallyReportSettings.categoryCutOffTime = text;
                        vm.tallyReportSettings.categoryScheduleTime = promise.cutoffOffsetInMinutes;
                    }
                });
            } else {
                vm.tallyReportSettings.areAllCategoriesSelected = true;
                vm.tallyReportSettings.categoryLeadTime = 0;
            }
        }
    };

    vm.closeFilterPopup = function() {
        vm.tallyReportSettings.showTemplateFilterPopup = false;
        getLatestAvailabilityForCategories();
    };

    /** Called when day is toggled in daily report */
    vm.changeDayEnabled = function(day) {
        day.selected = !day.selected;
    };

    vm.dateOptions = {
        startingDay: $rootScope.merchantInfo.contactDetails.country.weekStartingDay,
        showWeeks: false
    };

    init();
});



// WEBPACK FOOTER //
// ./src/reports/outlet/shared/tally.controller.js